<template>
  <div class="base-phone-input">
    <vue-phone-number-input
      class="base-phone-input__root"
      v-model="phoneNumber"
      default-country-code="UA"
      :only-countries="['UA', 'US', 'CA', 'GB', 'ES', 'IT', 'PL', 'FI']"
      size="lg"
      color="#11bb2e"
      id="phone"
      autocomplete="tel"
      :maxlength="maxLength"
      name="phone-number"
      :translations="{
        phoneNumberLabel: $t('Phone number'),
        example: $t('Example:')
      }"
      :no-validator-state="true"
      :required="required"
      :border-radius="5"
      @update="onUpdate"
      @input="$emit('input', $event)"
      @phone-number-blur="$emit('input', $event)"
    >
      <template #arrow>
        <span class="base-phone-input__country-arrow">▼</span>
      </template>
    </vue-phone-number-input>
    <ValidationMessages v-if="validations" :validations="validations" class="mb5" />
  </div>
</template>

<script>
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
const VuePhoneNumberInput = () => import(/* webpackChunkName: "vue-phone-number-input" */ 'vue-phone-number-input');
const ValidationMessages = () => import(/* webpackChunkName: "vsf-validation-messages" */ 'korzyna/components/core/blocks/Form/ValidationMessages.vue');

export default {
  name: 'BaseTelephoneInput',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    ValidationMessages,
    VuePhoneNumberInput
  },
  data: () => ({
    phone: {},
    phoneNumber: '',
    maxLength: 14
  }),
  methods: {
    onUpdate (value) {
      this.phone = value;
      if (value.isValid) {
        this.maxLength = 9;
      } else {
        this.maxLength = 14;
      }

      if ('nationalNumber' in value && /(.)\1{8}/.test(value.nationalNumber)) {
        this.maxLength = 9;
      }
      this.$emit('update', value);
    }
  },
  mounted () {
    this.phoneNumber = this.value;
  },
  watch: {
    value (value) {
      this.phoneNumber = value;
    }
  }
}
</script>

<style lang="scss">
.base-phone-input {
  min-height: 4.5rem;

  &__root {
    width: 100%;
    position: relative;
    z-index: 10;

    .select-country-container {
      .country-selector {
        &__label {
          display: none;
        }

        &__input {
          box-shadow: unset !important;
        }

        &__list {
          z-index: 10;

          .resize-observer {
            display: none;
          }
        }

        &.lg {
          min-height: 44px;
          height: 44px;

          .country-selector {
            &__input {
              min-height: 44px;
              height: 44px;
              padding-top: 10px;
              padding-bottom: 10px;
              font-size: 18px;
            }

            &__country-flag {
              top: 15px;
            }
          }
        }
      }
    }

    .flex-1 {
      .input-tel.lg {
        min-height: 44px;
        height: 44px;
      }

      .input-phone-number {
        input {
          box-shadow: unset !important;
          background-color: transparent;
          z-index: 15;

          &::placeholder {
            color: #999;
          }
        }

        &.lg {
          input {
            min-height: 44px;
            height: 44px;
            font-size: 16px;
          }

          &.has-value {
            input {
              font-size: 18px;
              padding-top: 10px;
              padding-bottom: 10px;
            }

            label {
              top: 0;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }

  &__country-arrow {
    color: #bdbdbd;
  }
}
</style>
